<div class="modal-dialog modal-dialog-centered">
  <div class="modal-content config-modal">

    <div class="modal-header border-0">
      <div>
        <h5 class="modal-title">Trocar de Cliente</h5>
        <small class="text-muted">
          Selecione o cliente desejado para continuar
        </small>
      </div>
      <button type="button" class="btn-close" (click)="dialogRef.close()"></button>
    </div>

    <div class="modal-body mt-3">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">

        <div class="col-sm-12 mb-3">
          <label class="cliente-label">Estado</label>
          <select class="form-control select" formControlName="estadoId">
            <option value="">Selecione</option>
            <option *ngFor="let estado of estados" [value]="estado.id">
              {{ estado.nome }}
            </option>
          </select>
        </div>

        <div class="col-sm-12 mb-3">
          <label class="cliente-label">Município</label>
          <select class="form-control select" formControlName="municipioId">
            <option value="">Selecione</option>
            <option *ngFor="let municipio of municipiosFiltrados" [value]="municipio.id">
              {{ municipio.nome }}
            </option>
          </select>
        </div>

        <div class="col-sm-12 mb-3">
          <label class="cliente-label">Cliente</label>
          <select class="form-control select" formControlName="clienteId">
            <option value="">Selecione</option>
            <option *ngFor="let cliente of clientesFiltrados" [value]="cliente.id">
              {{ cliente.nomeFantasia }}
            </option>
          </select>
        </div>

        <div class="modal-footer border-0">
          <button class="btn btn-cancelar-modal" (click)="dialogRef.close()">
            Cancelar
          </button>
          <button class="btn btn-sm btn-warning text-white" type="submit">
            Salvar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>